<template>
    <div class="flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">Attachment Version</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4 flex-1 d-flex flex-column overflow-auto">
            <div class="d-flex flex-wrap flex-fill">
                <div class="flex-1">
                    <v-text-field v-model="searchField" :placeholder="AttachmentId" @keyup="getAttachments"
                        solo></v-text-field>
                </div>
                
            </div>
            <div class="flex-1 mb-2">
                <Pagination :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                    :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>
            </div>

            <v-data-table id="templateList" class="position-relative white h-100 d-flex flex-column"
                :headers="attachmentHeaders" :items="attachments" hide-default-footer :items-per-page="pagingData.pageSize"
                disable-sort :no-data-text="$t('res_Label_NoData')">
                <template v-slot:item="row" item-key="id">
                    <tr @mouseover="selectItem(row.item)" @mouseleave="unSelectItem()">
                        <td style="display: none">{{ row.item.id }}</td>
                        <td>{{ row.item.version }}</td>
                        <td>{{ row.item.fileName }}</td>
                        <td>
                            <div class="onhover-display">

                                <div class="custom-icon-wrapper" v-if="constants.client_version_Id != 'ADNOC'">
                                    <v-icon @click="openAttachmentReplaceDialog(row.item.id)" v-tooltip.hover="$t('res_ButtonText_Rescan')" >mdi-file-replace</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="constants.client_version_Id != 'ADNOC'">
                                    <v-icon @click="downloadTemplate(row.item.id, row.item.fileName)" v-tooltip.hover="$t('res_MeetingForm_Download')" >mdi-download</v-icon>
                                </div>

                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>

		

        <v-dialog v-model="attachmentReplaceDialog" content-class="small-dialog" width="600">
            <v-card>
                <v-card-title>{{ $t("res_Label_Replace") }}</v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_Label_AttachTemplate") }}<span style="color: red"> *</span></label>
                    <v-file-input accept=".docx" label="" solo v-model="attachmentFileReplace" prepend-icon=""></v-file-input>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="attachmentReplaceDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn class="primary" @click="replaceAttachment()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import EditTemplate from '@/components/EditTemplate.vue'
import * as utils from '@/assets/js/common.js'
import Pagination from '@/components/Pagination.vue'
import TemplatePreview from '../views/admin/TemplatePreview.vue'
import StructureUserSelector from '@/components/StructureUserSelector.vue'

export default {
    name: 'AttachmentVersions',
    components: {TemplatePreview, Multiselect, EditTemplate, Pagination, StructureUserSelector },
    data() {
        return {
            loading: false,
            users: [],
            attachments: [],
            attachment: {},
            attachmentId: 0,
            versionId: '',
            attachmentFile: {},
            attachmentFileReplace: {},
            searchField: '',
            attachmentReplaceDialog: false,
            attachmentHeaders: [ 
                { text: this.$t("res_GridHeaders_fileName"), value: 'fileName', width: '10%' },
                { text: this.$t("res_GridHeaders_version"), value: 'version', width: '10%' },
                { text: this.$t("res_GridHeaders_Actions"), value: 'event', width: '30%', sortable: false }
            ],
            selectedItem: {},
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            constants: constants
        };
    },
    props: {
        structure_id: Number,
    },
    mounted() {
        
    },
    watch: {
        

    },
    methods:
    {
        
        getAttachments(isResetPaging) {
            if (isResetPaging) {
                this.pagingData.totalCount = 0;
                this.pagingData.pageIndex = 0;
            }

            this.attachments = [];
            this.attachment = {};
            
            axios.get(constants.baseApiUrl + 'ViewerActions/GetFileVersions_Admin?Id=' + this.searchField )
                .then(response => {
                    if (response.data != null) {
                        if (response.data.length > 0) {
                            this.pagingData.totalCount = response.data[0].totalCount;
                        }
                        this.attachments = [];
                        this.attachmentId=this.searchField
                        response.data.forEach((attachment) => {
                            var attachmentBody = {
                                id: attachment.id,
                                fileName: attachment.fileName || this.$t("res_Label_Unnamed"),
                                version: attachment.name
                                
                            }

                            this.attachments.push(attachmentBody)
                        });
                    }
                })
                .catch(err => console.warn(err))
                //.finally(() => );
        },
        
        updateEditTempalateData() {
            this.$refs.editTemp.updatedtemplateData()
        },
        openAttachmentReplaceDialog(versionId) {
            this.versionId = versionId
            this.attachmentReplaceDialog = true
        },
        downloadTemplate(attachmentVersion,filename) {
            utils.DownloadFile(constants.baseApiUrl + 'viewerActions/GetAttachment_Admin?Id=' + this.searchField+'&versionId='+attachmentVersion, (filename.includes('docx') ? filename : `${filename}.docx`))
        },        
        replaceAttachment() 
        {
            if (this.attachmentFileReplace.size != undefined) 
            {
                this.readFile(this.attachmentFileReplace, (fileBytes) => {
                    var attachment = {
                        versionId: this.versionId,
                        ItemBytes: fileBytes
                    }
                    let singleAttachment = new FormData();
                    singleAttachment.append('versionId', this.versionId)
                    singleAttachment.append('attachmentId', this.attachmentId)
                    
                    singleAttachment.append('file[0]', this.attachmentFileReplace)

                    const headers2 = {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
                    };
                    
                    axios.post(constants.baseApiUrl + 'viewerActions/Replace_Admin', singleAttachment, { headers: headers2 })
                        .then(response => {
                            if (response.data != null) {
                                window.showAlert(this.$t("res_Msgs_AttachmentReplaced"), "success")
                                this.attachmentReplaceDialog = false
                                this.getAttachments()
                            }
                        })
                        .catch(err => console.warn(err))
                });
            }
        },
        async readFile(file, successHandler) {
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    successHandler(fileByteArray);
                }
            }
        },
        selectItem(item) {
            this.selectedItem = item
        },
        unSelectItem(item) {
            this.selectedItem = false
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.getTemplates();
        },
        
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>